






































import { Component, Vue, Prop } from 'vue-property-decorator'
import TapSortingStatementItem from '@/components/common/sorting/TapSortingStatementItem.vue'
import { StatementSortingOptions } from '@/interfaces/SortingInterfaces'

@Component({
  name: 'TapSortingStatement',
  components: { TapSortingStatementItem }
})
export default class TapSortingStatement extends Vue {
  @Prop({
    default: {
      list: []
    }
  })
  options!: StatementSortingOptions

  totalStatementCount: number = 0
  resultList: object[] = []

  created () {
    this.totalStatementCount = this.options.list.length
    this.resultList = []
  }

  get isConfirmDisabled () : boolean {
    return this.resultList.length !== this.totalStatementCount
  }

  moveItemToOrder (rawItemIndex: number) {
    this.resultList.push(this.options.list[rawItemIndex])
    this.options.list.splice(rawItemIndex, 1)
  }

  removeItemFromOrder (orderedItemIndex: number) {
    this.options.list.push(this.resultList[orderedItemIndex])
    this.resultList.splice(orderedItemIndex, 1)
  }

  updateOrder () {
    if (this.isConfirmDisabled) {
      return
    }

    this.$emit('updateOrder', this.resultList)
    this.resultList = []
  }
}
